<app-auth-layout [loading]="loading">
    <div class="row m-5">
        
    <div 
    class="text-right mb-5">
     <a
       routerLink="/application/login"
       class="font-bold text-sm text-primary inline-block align-baseline hover:text-primary-dark hover:underline"
     >
     Application Portal Login
     </a>
   </div>
        <form (ngSubmit)="createFamilyProfile()" class="flex flex-col h-full">
          <h1
            class="font-bold py- text-center text-lg pb-4 uppercase md:text-xl md:pb-8 lg:text-2xl"
          >
            Create Family
          </h1>
      
          <app-notification-alert [data]="notification"></app-notification-alert>
    
          
          <app-guardian-form-fields [companies]="companies" [createFamilyProfile]="true" [states]="states" [ChildLeavingWith]="ChildLeavingWith" [guardianToSave]="guardianToSave" ></app-guardian-form-fields>
      
          <div class="py-1">
            <app-button-primary type="submit" [disabled]="loading" class="w-full">
              Submit
            </app-button-primary>
          </div>
        </form>

    </div>
  </app-auth-layout>
  